import * as React from 'react';
import { SimpleLazyLoadWrapper } from '../common/lazy/simple-lazy-load-wrapper';
export const LazyLoadWrapper = ({
  useLazyLoading,
  children
}) => useLazyLoading ? React.createElement(SimpleLazyLoadWrapper, null, children) : React.createElement(React.Fragment, null, children);